<!-- Purchase Manager Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Purchase Manager Listing Component -->
  <app-purchase-manager-listing #purchaseManagerListing>
  </app-purchase-manager-listing>
</div>

<!-- Purchase Manager Add/Edit Modal -->
<app-add-edit-purchase-manager
  (purchaseManagerAdded)="onPurchaseManagerAdded()"
  (purchaseManagerUpdated)="onPurchaseManagerUpdated()">
</app-add-edit-purchase-manager>
